import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.css'
import { CardWrapper, CardContent, CardInnerHeading } from '../../../shared/settings/card'

function DcbSubscription({ dcbSubscriptionInfo }) {
  const { header, content } = dcbSubscriptionInfo
  return (
    <CardWrapper>
      <CardContent className={styles.cardContent}>
        <CardInnerHeading header={header} subHeader={content} />
      </CardContent>
    </CardWrapper>
  )
}

DcbSubscription.propTypes = {
  dcbSubscriptionInfo: PropTypes.shape({
    partnerName: PropTypes.string,
    header: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired
  }).isRequired
}

export default DcbSubscription
